export const Colors: any = {
  light: {
    text: '#000',
    back: '#ffffff',
  },
  dark: {
    text: '#ffffff',
    back: '#2B2D2E',
  },
  default: '#3498db',
  info: '#3498db',
  success: '#07bc0c',
  warn: '#f1c40f',
  error: '#e74c3c',
  textDefault: '#4c4c4c',
  textDark: 'black',
}
